var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2608204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3865 8.91955C13.5368 8.91955 15.2799 7.1467 15.2799 4.95977C15.2799 2.77285 13.5368 1 11.3865 1C9.23629 1 7.49316 2.77285 7.49316 4.95977C7.49316 7.1467 9.23629 8.91955 11.3865 8.91955Z",
    fill: "#61676B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.37793 18.9999H11.689H19V18.1325C18.9871 16.913 18.6605 15.7167 18.0507 14.6552C17.441 13.5937 16.568 12.7017 15.5133 12.0626C14.4586 11.4234 13.2566 11.0579 12.0196 11.0002C11.9093 10.9951 11.7991 10.9924 11.689 10.9922C11.5788 10.9924 11.4686 10.9951 11.3583 11.0002C10.1213 11.0579 8.9193 11.4234 7.8646 12.0626C6.8099 12.7017 5.93692 13.5937 5.32718 14.6552C4.71745 15.7167 4.39086 16.913 4.37793 18.1325V18.9999Z",
    fill: "#61676B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00861 9.41955C10.4429 9.41955 12.402 7.41484 12.402 4.95977C12.402 2.50471 10.4429 0.5 8.00861 0.5C5.57428 0.5 3.61523 2.50471 3.61523 4.95977C3.61523 7.41484 5.57428 9.41955 8.00861 9.41955Z",
    fill: "#61676B",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.5 18.9999C0.5 19.276 0.723858 19.4999 1 19.4999H8.31103H15.6221C15.8982 19.4999 16.1221 19.276 16.1221 18.9999V18.1325H16.1221L16.122 18.1272C16.1082 16.8218 15.7586 15.5415 15.1064 14.4061C14.4542 13.2708 13.521 12.3176 12.3945 11.6349C11.2681 10.9523 9.985 10.5623 8.66497 10.5008C8.54727 10.4953 8.42962 10.4924 8.3121 10.4922L8.30996 10.4922C8.19244 10.4924 8.07479 10.4953 7.9571 10.5008C6.63706 10.5623 5.35393 10.9523 4.22754 11.6349C3.1011 12.3176 2.16786 13.2708 1.51569 14.4061C0.86349 15.5415 0.513873 16.8218 0.500028 18.1272L0.5 18.1272V18.1325V18.9999Z",
    fill: "#61676B",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersfilled);
export default __webpack_public_path__ + "static/media/usersfilled.b7ab774cec67c1bb6ad7e84e3b88ec1b.svg";
export { ForwardRef as ReactComponent };